var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "container" }, [
    _c("br"),
    _c("br"),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "jumbotron" },
      [
        _c("h1", { staticClass: "display-4" }, [
          _vm._v("Share " + _vm._s(_setup.resourceName)),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "lead" }, [
          _vm._v("You are about to share "),
          _c("strong", [_vm._v(_vm._s(_setup.resourceName))]),
          _vm._v(" owned by "),
          _c("strong", [_vm._v(_vm._s(_setup.organizationName))]),
          _vm._v(" data in TransparentChoice application"),
        ]),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _c("table", { staticClass: "table table-sm" }, [
          _c("thead", [
            _c(
              "tr",
              _vm._l(_setup.dataShareEmailsProviders, function (p) {
                return _c("th", { key: p.Name, attrs: { scope: "col" } }, [
                  _c("div", { staticClass: "form-check form-check-inline" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _setup.emailsProviderName,
                          expression: "emailsProviderName",
                        },
                      ],
                      staticClass: "form-check-input",
                      attrs: { type: "radio", id: p.Name, name: p.Name },
                      domProps: {
                        value: p.Name,
                        checked: _vm._q(_setup.emailsProviderName, p.Name),
                      },
                      on: {
                        change: function ($event) {
                          _setup.emailsProviderName = p.Name
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "form-check-label",
                        attrs: { for: p.Name },
                      },
                      [_vm._v(_vm._s(p.Title))]
                    ),
                  ]),
                ])
              }),
              0
            ),
          ]),
          _vm._v(" "),
          _c("tbody", [
            _c(
              "tr",
              _vm._l(_setup.dataShareEmailsProviders, function (p) {
                return _c("td", { key: p.Name }, [
                  _vm._v(_vm._s(p.Description)),
                ])
              }),
              0
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", [
          _c(
            "a",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _setup.groups.length > 0,
                  expression: "groups.length>0",
                },
              ],
              attrs: {
                "data-toggle": "collapse",
                href: "#groupsCollapse",
                role: "button",
              },
            },
            [_vm._v("Select groups")]
          ),
          _vm._v(" \n            "),
          _c(
            "a",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _setup.emails.length > 0,
                  expression: "emails.length>0",
                },
              ],
              attrs: {
                "data-toggle": "collapse",
                href: "#emailsCollapse",
                role: "button",
              },
            },
            [_vm._v("Select people")]
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "collapse", attrs: { id: "groupsCollapse" } },
          [
            _c(
              "div",
              { staticClass: "card card-body" },
              _vm._l(_setup.groups, function (g) {
                return _c(
                  "div",
                  { key: g.Name, staticClass: "form-check form-check-inline" },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _setup.emailsProviderGroups,
                          expression: "emailsProviderGroups",
                        },
                      ],
                      staticClass: "form-check-input",
                      attrs: { type: "checkbox", id: `g_${g.Name}` },
                      domProps: {
                        value: g.Name,
                        checked: Array.isArray(_setup.emailsProviderGroups)
                          ? _vm._i(_setup.emailsProviderGroups, g.Name) > -1
                          : _setup.emailsProviderGroups,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _setup.emailsProviderGroups,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = g.Name,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                (_setup.emailsProviderGroups = $$a.concat([
                                  $$v,
                                ]))
                            } else {
                              $$i > -1 &&
                                (_setup.emailsProviderGroups = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _setup.emailsProviderGroups = $$c
                          }
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "form-check-label",
                        attrs: { for: `g_${g.Name}` },
                      },
                      [_vm._v(_vm._s(g.Name))]
                    ),
                  ]
                )
              }),
              0
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "collapse", attrs: { id: "emailsCollapse" } },
          [
            _c(
              "div",
              { staticClass: "card card-body" },
              _vm._l(_setup.emails, function (e) {
                return _c(
                  "div",
                  { key: e.Name, staticClass: "form-check form-check-inline" },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _setup.emailsProviderGroups,
                          expression: "emailsProviderGroups",
                        },
                      ],
                      staticClass: "form-check-input",
                      attrs: { type: "checkbox", id: `e_${e.Name}` },
                      domProps: {
                        value: e.Name,
                        checked: Array.isArray(_setup.emailsProviderGroups)
                          ? _vm._i(_setup.emailsProviderGroups, e.Name) > -1
                          : _setup.emailsProviderGroups,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _setup.emailsProviderGroups,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = e.Name,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                (_setup.emailsProviderGroups = $$a.concat([
                                  $$v,
                                ]))
                            } else {
                              $$i > -1 &&
                                (_setup.emailsProviderGroups = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _setup.emailsProviderGroups = $$c
                          }
                        },
                      },
                    }),
                    _vm._v(" "),
                    e.IsUser
                      ? _c("span", {
                          staticClass: "fa fa-user text-success",
                          attrs: { title: "User" },
                        })
                      : _c("span", {
                          staticClass: "fa-regular fa-user text-secondary",
                          attrs: { title: "Not an user" },
                        }),
                    _vm._v("\n                     \n                    "),
                    _c(
                      "label",
                      {
                        staticClass: "form-check-label",
                        attrs: { for: `e_${e.Name}`, value: e },
                      },
                      [_vm._v(_vm._s(e.Name))]
                    ),
                  ]
                )
              }),
              0
            ),
          ]
        ),
        _vm._v(" "),
        _c("ValidationError", {
          attrs: {
            context: "EmailsProviderName",
            errors: _setup.validationErrors,
          },
        }),
        _vm._v(" "),
        _c("hr"),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _setup.sharedForAvailableHours &&
          _setup.sharedForAvailableHours.length > 0
            ? _c(
                "div",
                { staticClass: "col-sm-4" },
                [
                  _vm._l(_setup.sharedForAvailableHours, function (v) {
                    return [
                      _c("div", { staticClass: "form-check" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _setup.sharedFor,
                              expression: "sharedFor",
                            },
                          ],
                          staticClass: "form-check-input",
                          attrs: {
                            type: "radio",
                            name: "sharedFor",
                            id: `sharedFor.${v.Value}`,
                          },
                          domProps: {
                            value: v.Value,
                            checked: _vm._q(_setup.sharedFor, v.Value),
                          },
                          on: {
                            change: function ($event) {
                              _setup.sharedFor = v.Value
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "form-check-label",
                            attrs: { for: `sharedFor.${v.Value}` },
                          },
                          [_vm._v("Share for " + _vm._s(v.Name))]
                        ),
                      ]),
                    ]
                  }),
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _setup.sharedForAvailableDays &&
          _setup.sharedForAvailableDays.length > 0
            ? _c(
                "div",
                { staticClass: "col-sm-4" },
                [
                  _vm._l(_setup.sharedForAvailableDays, function (v) {
                    return [
                      _c("div", { staticClass: "form-check" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _setup.sharedFor,
                              expression: "sharedFor",
                            },
                          ],
                          staticClass: "form-check-input",
                          attrs: {
                            type: "radio",
                            name: "sharedFor",
                            id: `sharedFor.${v.Value}`,
                          },
                          domProps: {
                            value: v.Value,
                            checked: _vm._q(_setup.sharedFor, v.Value),
                          },
                          on: {
                            change: function ($event) {
                              _setup.sharedFor = v.Value
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "form-check-label",
                            attrs: { for: `sharedFor.${v.Value}` },
                          },
                          [_vm._v("Share for " + _vm._s(v.Name))]
                        ),
                      ]),
                    ]
                  }),
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "col-sm-4" }, [
            _c("div", { staticClass: "form-check" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _setup.sharedFor,
                    expression: "sharedFor",
                  },
                ],
                staticClass: "form-check-input",
                attrs: {
                  type: "radio",
                  name: "sharedFor",
                  id: "sharedFor.forever",
                },
                domProps: {
                  value: null,
                  checked: _vm._q(_setup.sharedFor, null),
                },
                on: {
                  change: function ($event) {
                    _setup.sharedFor = null
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "form-check-label",
                  attrs: { for: "sharedFor.forever" },
                },
                [_vm._v("Share forever")]
              ),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _setup.numberOfShares > 0
          ? _c(
              "a",
              {
                staticClass: "btn btn-lg btn-secondary m-1",
                attrs: {
                  href: `/#/sharing/resource/${_setup.provider}/${_setup.resourceId}`,
                },
              },
              [_vm._v("Back")]
            )
          : _c(
              "a",
              {
                staticClass: "btn btn-lg btn-secondary m-1",
                attrs: { href: _setup.resourceUrl },
              },
              [_vm._v("Back")]
            ),
        _vm._v(" "),
        _setup.exists && !_setup.isPaused
          ? _c(
              "button",
              {
                staticClass: "btn btn-lg btn-secondary m-1",
                on: { click: _setup.invokePauseSharingCommandV1 },
              },
              [_vm._v("Pause sharing")]
            )
          : _vm._e(),
        _vm._v(" "),
        _setup.exists && _setup.isPaused
          ? _c(
              "button",
              {
                staticClass: "btn btn-lg btn-secondary m-1",
                on: { click: _setup.invokeResumeSharingCommandV1 },
              },
              [_vm._v("Resume sharing")]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-lg btn-primary pull-right m-1",
            on: { click: _setup.invokeShareDataCommandV1 },
          },
          [_vm._v("Share")]
        ),
        _vm._v(" "),
        _setup.exists
          ? _c(
              "button",
              {
                staticClass: "btn btn-lg btn-danger pull-right m-1",
                on: { click: _setup.handleDeleteShareCommandV1 },
              },
              [_vm._v("Delete share")]
            )
          : _vm._e(),
        _vm._v(" "),
        _setup.authenticatedUserRequired
          ? _c("div", { staticClass: "mt-4" }, [
              _c("strong", [
                _vm._v(
                  "\n                To share " +
                    _vm._s(_setup.resourceName) +
                    " the user must have Business User access to the software.\n            "
                ),
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("span", [
                _vm._v("\n                This should be requested via the "),
                _c(
                  "a",
                  {
                    attrs: {
                      href: `/#/pp/people/${_setup.workspaceId}/${_setup.projectId}`,
                      target: "_blank",
                    },
                  },
                  [_vm._v("People")]
                ),
                _vm._v(
                  "\n                section & approved by your workspace admin to enable instant access to this project.\n            "
                ),
              ]),
            ])
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }